<template>
  <div class="app" ref="app">
    <div v-if="pages.length > 0" class="page-list">
      <div style="display:flex;flex-direction: column;align-items: flex-end;padding-right: 10px;">
       <a-button v-if="canEdit" style="margin-left: auto;" type="primary" @click="editPage()">编辑</a-button>
      </div>
      <div class="cell" ref="dragbox">
        <div class="dragbox" :style="{ height: (750 * dragboxWidth) / wrapperWidth + 'px' }">
          <div class="wrapper" :style="{
            transform: `scale(${dragboxWidth / wrapperWidth})`,
          }">
            <div class="wrap2" :style="{
              width: wrapperWidth + 'px',
              height: 750 + 'px',
              backgroundImage: 'url(' + back1 + ')',
              backgroundSize: '100% 100%',
              backgroundColor: '#cccccc',
            }">
              <vue-draggable-resizable :w="item.width" :h="item.height" :x="item.left" :y="item.top" :r="item.rotate"
                :z="item.zIndex" :photoRotate="item.photoRotate" :levelType="item.levelType" :level="item.level"
                :levelNum="item.levelNum" :showPhoto="item.showPhoto" :shadow="item.shadow ? true : false"
                :photoLeft="item.photoLeft"
                :photoTop="item.photoTop"
                :allIndex="drags.length - 1" :dIndex="index" :debug="false" :disable="true"
                :lineHeight="item.lineHeight" :fontWeight="item.fontWeight" :fontStyle="item.fontStyle"
                :textAlign="item.textAlign" :type="item.type" :isConflictCheck="false" :snap="true" :snapTolerance="1"
                :lockAspectRatio="item.lockAspectRatio ? true : false"
                :backImg="item.backgroundImg ? item.backgroundImg : ''" :bImg2="item.backImg2"
                :bRadius="item.borderRadius" :fontColor="item.fColor" :text="item.textarea" :o="item.opacity"
                dragHandle="false" :l="item.lock ? true : false" :backColor="item.bColor"
                :borderColor="item.bordersColor" :borderLeft="item.bLeft" :borderTop="item.bTop"
                :borderRight="item.bRight" :borderBottom="item.bBottom" :borderStyle="item.bStyle"
                :paddingLeft="item.paddingLeft" :paddingTop="item.paddingTop" :paddingRight="item.paddingRight"
                :paddingBottom="item.paddingBottom" :active="false" :fontSize="item.fSize"
                v-for="(item, index) in drags" :key="item.ec_id">
                <div v-if="item.type == 3" class="look" style="z-index:-1">
                  <div class="wrap" :style="{
                    width: item.width + 'px',
                    height: item.height + 'px',
                    transform: `scale(${item.width /
                      item.orignWidth},${item.height / item.orignHeight})`,
                    transformOrigin: '0px 0px',
                  }">
                    <vue-draggable-resizable v-for="item2 in item.coms" :key="item2.ebu_id" :w="item2.width"
                      :h="item2.height" :enableNativeDrag="true" :x="item2.left" :y="item2.top" :r="item2.rotate"
                      :z="item2.zIndex" :showPhoto="item2.showPhoto" :shadow="item2.shadow ? true : false"
                      :dIndex="index" :debug="false" :disable="true" :lineHeight="item2.lineHeight"
                      :fontWeight="item2.fontWeight" :fontStyle="item2.fontStyle" :textAlign="item2.textAlign"
                      :type="item2.type" :isConflictCheck="false" :snap="true" :snapTolerance="1"
                      :lockAspectRatio="item2.lockAspectRatio ? true : false"
                      :backImg="item2.backgroundImg ? item2.backgroundImg : ''" :bImg2="item2.backImg2"
                      :bRadius="item2.borderRadius" :fontColor="item2.fColor" :text="item2.textarea" :o="item2.opacity"
                      :l="item2.lock ? true : false" dragHandle="false" :backColor="item2.bColor"
                      :borderColor="item2.bordersColor" :borderLeft="item2.bLeft" :borderTop="item2.bTop"
                      :borderRight="item2.bRight" :borderBottom="item2.bBottom" :borderStyle="item2.bStyle"
                      :paddingLeft="item2.paddingLeft" :paddingTop="item2.paddingTop" :paddingRight="item2.paddingRight"
                      :paddingBottom="item2.paddingBottom" :active="false" :fontSize="item2.fSize">
                    </vue-draggable-resizable>
                  </div>
                </div>
              </vue-draggable-resizable>
              <!-- <vue-draggable-resizable
                v-for="(item, index2) in drags"
                :key="item.ec_id"
                :w="item.width"
                :h="item.height"
                :enableNativeDrag="true"
                :isDraggable="false"
                :isResizable="false"
                :x="item.left"
                :y="item.top"
                :r="item.rotate"
                :z="item.zIndex"
                :levelNum="item.levelNum"
                :photoRotate="item.photoRotate"
                :levelType="item.levelType"
                :level="item.level"
                :frameId="'item' + index2"
                :photoScale="item.photoScale"
                :photoLeft="item.photoLeft"
                :photoTop="item.photoTop"
                :showPhoto="item.showPhoto"
                :shadow="item.shadow ? true : false"
                :allIndex="item.allIndex"
                :dIndex="index2"
                :debug="false"
                :disable="true"
                :lineHeight="item.lineHeight"
                :fontWeight="item.fontWeight"
                :fontStyle="item.fontStyle"
                :textAlign="item.textAlign"
                :type="item.type"
                :isConflictCheck="false"
                :snap="true"
                :snapTolerance="1"
                :lockAspectRatio="item.lockAspectRatio ? true : false"
                :backImg="item.backgroundImg ? item.backgroundImg : ''"
                :bImg2="item.backImg2"
                :bRadius="item.borderRadius"
                :fontColor="item.fColor"
                :text="item.textarea"
                :o="item.opacity"
                :l="item.lock ? true : false"
                dragHandle="false"
                :backColor="item.bColor"
                :borderColor="item.bordersColor"
                :borderLeft="item.bLeft"
                :borderTop="item.bTop"
                :borderRight="item.bRight"
                :borderBottom="item.bBottom"
                :borderStyle="item.bStyle"
                :paddingLeft="item.paddingLeft"
                :paddingTop="item.paddingTop"
                :paddingRight="item.paddingRight"
                :paddingBottom="item.paddingBottom"
                :active="false"
                :isActive="false"
                :fontSize="item.fSize"
              >
                <div v-if="item.type == 3" class="look" style="z-index:-1">
                  <div
                    class="wrap"
                    :style="{
                      width: item.width + 'px',
                      height: item.height + 'px',
                      transform: `scale(${item.width /
                        item.orignWidth},${item.height / item.orignHeight})`,
                      transformOrigin: '0px 0px',
                    }"
                  >
                    <vue-draggable-resizable
                      v-for="(item2, index3) in item.coms"
                      :key="index3"
                      :w="item2.width"
                      :h="item2.height"
                      :x="item2.left"
                      :y="item2.top"
                      :r="item2.rotate"
                      :z="item2.zIndex"
                      :frameId="'build' + index3"
                      :levelType="item.levelType"
                      :showPhoto="item2.showPhoto"
                      :shadow="item2.shadow ? true : false"
                      :allIndex="item.coms.length - 1"
                      :dIndex="index3"
                      :debug="false"
                      :disable="true"
                      :lineHeight="item2.lineHeight"
                      :fontWeight="item2.fontWeight"
                      :fontStyle="item2.fontStyle"
                      :textAlign="item2.textAlign"
                      :type="item2.type"
                      :isConflictCheck="false"
                      :snap="true"
                      :snapTolerance="1"
                      :lockAspectRatio="item2.lockAspectRatio ? true : false"
                      :backImg="item2.backgroundImg ? item2.backgroundImg : ''"
                      :bImg2="item2.backImg2"
                      :bRadius="item2.borderRadius"
                      :fontColor="item2.fColor"
                      :text="item2.textarea"
                      :o="item2.opacity"
                      :l="item2.lock ? true : false"
                      dragHandle="false"
                      :backColor="item2.bColor"
                      :borderColor="item2.bordersColor"
                      :borderLeft="item2.bLeft"
                      :borderTop="item2.bTop"
                      :borderRight="item2.bRight"
                      :borderBottom="item2.bBottom"
                      :borderStyle="item2.bStyle"
                      :paddingLeft="item2.paddingLeft"
                      :paddingTop="item2.paddingTop"
                      :paddingRight="item2.paddingRight"
                      :paddingBottom="item2.paddingBottom"
                      :active="false"
                      :fontSize="item2.fSize"
                    ></vue-draggable-resizable>
                  </div>
                </div>
              </vue-draggable-resizable> -->
            </div>
          </div>
        </div>
        <div class="footer flex-row">
          <a-button :disabled="currentPage == 0" @click="minPage" type="">上一页</a-button>
          <div class="name">
            {{
                pages[currentPage].type == 1
                  ? "封面"
                  : pages[currentPage].type == 3
                    ? "封底"
                    : pages[currentPage].page_num
            }}
          </div>
          <a-button :disabled="currentPage == pages.length - 1" @click="addPage" type="">下一页</a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueDraggableResizable from "../components/vue-draggable-resizable";
import "../components/vue-draggable-resizable.css";
import _ from "lodash";
import { mapState } from "vuex";

export default {
  name: "mobileGrowup",
  components: {
    VueDraggableResizable,
  },
  data() {
    return {
      back1: "",
      pages: [],
      drags: [],
      id: "",
      s_id: "",
      page: 0,
      allIndex: 0,
      wrapperWidth: 500,
      cover_size: [],
      dragboxWidth: 200,
      dragboxWidth: 200,
      gu_id: "",
      currentPage: 0,
      is_complete: false,
      student: "",
      canEdit:false
    };
  },
  computed: {
    ...mapState(["headers", "userInfo", "fonts"]),
    leftChatStyle() {
      return {
        cursor: this.leftChatMouseStateMove ? "grab" : "auto",
      };
    },
    wrapperStyle() {
      return {
        width: this.wrapperWidth + "px",
        height: 750 + "px",
        transform: `scale(${this.sizeSelct / 100}) translate(${this.bodyTranslateX
          }px,${this.bodyTranslateY}px)`,
      };
    },
  },
  mounted() {
    this.dragboxWidth = document.body.clientWidth - 20;
    window.onresize = () => {
      this.dragboxWidth = document.body.clientWidth - 20;
    };
  },
  created() {
    this.id = this.$route.params.sid;
    this.guc_id = this.$route.params.guc_id;
    if (this.headers) {
      this.getGrowupDetail();
    }
    //获取地址栏参数
    const edit = this.getParams(window.location.href,"edit");
    console.log(edit);
    this.canEdit = edit == 1
    // this.getPlate();
  },
  watch: {
    headers(val) {
      if (val) {
        this.getGrowupDetail();
      }
    },
  },
  methods: {
    //根据名称获取地址栏参数
    getParams(url,name) {
      if (!url || typeof url !== 'string') {
        return null;
      }
      let params = url.split("?")[1];
      if (!params) {
        return null;
      }
      let paramsObj = params.split("&").reduce((prev, cur) => {
        let [key, value] = cur.split("=");
        prev[key] = value;
        return prev;
      }, {});
      return paramsObj[name] || null;
    },
    editPage(index) {
      console.log(index);
      this.$router.push({
        path: `/mobileEditPlateRecord/${this.student.id}/${this.guc_id}/${this.userInfo.class_id}`,
        // path: `/editplate/${this.student.id}/${this.guc_id}`,
        query: { name: this.student.name, page: this.currentPage },
      });
    },
    getGrowupDetail() {
      this.$axios({
        method: "GET",
        url: this.$api.domain + this.$api.growupDetail,
        headers: { Authorization: this.headers },
        params: {
          guc_id: this.guc_id,
          s_id: this.id,
        },
      })
        .then((res) => {
          if (res.data.status == 200 && res.data.data) {
            this.pages = res.data.data.page;
            this.student = res.data.data.student.length > 0 ? res.data.data.student[0] : "";
            console.log(this.student);
            this.getAllGrowupDetail();
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    getAllGrowupDetail() {
      this.$axios({
        method: "GET",
        url: this.$api.domain + this.$api.growupDetail,
        headers: { Authorization: this.headers },
        params: {
          guc_id: this.pages[this.currentPage].guc_id,
          s_id: this.id,
        },
      })
        .then((res) => {
          if (res.data.status == 200 && res.data.data) {
            this.gu_id = res.data.data.info.gu_id;
            this.drags = res.data.data.info.content;
            var cover_size = res.data.data.info.size.cover_size.split("*");
            this.wrapperWidth = (cover_size[0] * 750) / cover_size[1];
            this.is_complete = res.data.data.info.is_complete ? true : false;
            this.drags = this.drags.map((arr) => {
              arr.textarea = decodeURI(arr.textarea);
              arr.active = false;
              if (arr.coms) {
                arr.coms = JSON.parse(arr.coms);
                if (arr.coms[0] && arr.coms[0].width >= 0) {
                } else {
                  arr.coms = [];
                }
              }
              return arr;
            });
            this.back1 = res.data.data.info.img_bg;
          }
        })
        .catch((res) => {
          // this.$message.error(res.data.msg);
        });
    },
    addPage() {
      if (this.currentPage == this.pages.length - 1) {
        this.$message.info("当前已是最后一页");
        return false;
      }
      this.currentPage++;
      this.getAllGrowupDetail();
    },
    minPage() {
      if (this.currentPage == 0) {
        this.$message.info("当前已是第一页");
        return false;
      }
      this.currentPage--;
      this.getAllGrowupDetail();
    },
    urladd(name) {
      var url = location.href;
      let str = url.indexOf("?");
      let num = url.slice(str + 1);
      let a = num.split("&");
      var list = {};
      for (var key in a) {
        list[key] = a[key];
        let b = list[key].indexOf("=");
        let c = list[key].substring(0, b);
        if (c == name) {
          let d = list[key].substring(b + 1);
          return d;
        }
      }
    },
    getPlate() {
      this.$axios({
        method: "GET",
        url: this.$api.domain + this.$api.parentGrowupList,
        headers: { Authorization: this.headers },
        params: {
          s_id: this.$route.params.s_id,
          page: 1,
          limit: 1000,
        },
      })
        .then((res) => {
          console.log(res.data.data.data);
          if (res.data.status == 200 && res.data.data.data[0].gu_id) {
            this.gu_id = res.data.data.data[0].gu_id;

            this.is_complete =
              res.data.data.data[0].is_complete == 0 ? false : true;
            this.getDetail(res.data.data.data[0].c_id);
            this.getGrowPages();
          }
        })
        .catch((res) => {
          this.$message.error("未获取到gu_id");
        });
    },
    getDetail(id) {
      this.$axios({
        method: "GET",
        url: this.$api.domain + this.$api.parentGrowDetail,
        headers: { Authorization: this.$store.state.headers },
        params: {
          c_id: id,
          s_id: this.babyInfo.id,
        },
      })
        .then((res) => {
          var cover_size = res.data.data.info.cover_size.split("*");
          this.cover_size = cover_size;
          this.haomi = (11.8 * 3 * 750) / cover_size[1];
          this.wrapperWidth = (cover_size[0] * 750) / cover_size[1];
          this.loadmodal = this.$message.loading("加载中");
        })
        .catch((res) => {
          // this.$message('请求错误')
        });
    },
    getGrowPages() {
      this.$axios({
        method: "GET",
        url: this.$api.domain + this.$api.parentContentList,
        // headers: { Authorization: this.headers },
        params: {
          gu_id: this.gu_id,
          s_id: this.$route.params.s_id,
        },
      })
        .then((res) => {
          if (res.data.status == 200 && res.data.data) {
            this.pages2 = res.data.data;
            this.pages2.forEach((arr, index) => {
              this.pages2[index].img_bg = this.pages2[index].img_bg +=
                "?x-image-process=image/resize,w_840/quality,Q_60";
              this.pages2[index].content = arr.content.map((arr2) => {
                // arr.textarea = decodeURI(arr.textarea);
                arr2.allIndex = arr.content.length - 1;
                arr2.draggable = false;
                arr2.backgroundImg = arr2.backgroundImg
                  ? arr2.backgroundImg +
                  "?x-image-process=image/resize,w_600/quality,Q_40"
                  : "";
                arr2.showPhoto = arr2.showPhoto
                  ? arr2.showPhoto +
                  "?x-image-process=image/resize,w_600/quality,Q_40"
                  : "";
                return arr2;
              });
            });
            this.$forceUpdate();
          }
        })
        .catch((res) => {
          console.log(res);
          this.$message.error(res.data.msg);
        });
    },
    urladd(name) {
      let url = window.location.href;
      let str = url.indexOf("?");
      let num = url.slice(str + 1);
      let a = num.split("&");
      var list = {};
      for (var key in a) {
        list[key] = a[key];
        let b = list[key].indexOf("=");
        let c = list[key].substring(0, b);
        if (c == name) {
          let d = list[key].substring(b + 1);
          return d;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.app {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.body {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}

.student-list {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}

.content img {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}

.photo-item {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
  width: 99px;
  float: left;
  box-sizing: border-box;
  margin: 10px;
  position: relative;

  .img {
    width: 100%;
    height: auto;
  }

  .img2 {
    width: 100%;
    height: auto;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
  }
}

.dragtext {
  width: 99px;
  height: 99px;
  text-align: center;
  line-height: 99px;
  color: #333;
  border: 1px solid #666;
  margin-bottom: 10px;
}

.photo-item .look {
  width: 100%;
  margin-bottom: 10px;
  box-sizing: border-box;
  overflow: hidden;
}

.back-item {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
  width: 100px;
  float: left;
  box-sizing: border-box;
  margin: 6px 10px;
}

.plate-list {
  margin-top: 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;

  .cell {
    width: 134px;
    margin-right: 20px;
    height: 180px;
    background: #eee;
    position: relative;
    margin-bottom: 60px;

    &.select {
      border: 2px solid #9ebee4;
    }

    .name {
      position: absolute;
      left: 0;
      top: 185px;
      color: #888;
      line-height: 1.2;
      padding: 5px;
      box-sizing: border-box;
    }

    &:nth-child(5n) {
      margin-right: 0;
    }
  }
}

.back-item .back {
  width: 100%;
  margin-bottom: 10px;
  box-sizing: border-box;
  position: relative;

  .times {
    position: absolute;
    right: 0;
    top: 0;
    padding: 4px 6px;
    color: #fff;
    background: #ff0000;
    border-radius: 16px;
    text-align: center;
    font-size: 12px;
    line-height: 1;
    transform: translate(50%, -50%);
  }
}

.back-item .back .img {
  width: 100%;
  height: auto;
  max-height: 160px;
  background: #f3f3f3;
  display: block;
}

.photo-item .look .img {
  width: 100%;
  background: #f3f3f3;
  display: block;
}

.photo-item .name {
  text-align: center;
}

body,
html {
  background: #f3f3f3;
  padding: 0;
  box-sizing: border-box;
  margin: 0;
}

.page-list {
  width: 100%;
  overflow: hidden;

  .cell {
    width: 100%;
    position: relative;
    float: left;
    margin: 10px 0;
    overflow: hidden;

    // &::after{
    //   position: absolute;
    //   left: 0;
    //   top: 0;
    //   right: 0;
    //   bottom: 0;
    //   content:"";
    // }
    .dragbox {
      width: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }

    .cover {
      width: 120px;
      height: 170px;
      background: #eee;
      margin-bottom: 15px;
      background-size: contain;
    }

    .name {
      color: #666666;
      font-size: 14px;
      text-align: center;
      height: 20px;
      margin-top: 10px;
      line-height: 20px;
      z-index: 100;
    }
  }
}

.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
}

.wrap2 {
  overflow: hidden;
}
</style>
